import { PromoBannersIdFiltersType } from '../containers/PromoBannersIdFiltersForm/PromoLandingsFiltersForm.types'

export const preparePromoBannerIdFiltersInput = (values?: PromoBannersIdFiltersType) => ({
  ...values,
})
